export default __webpack_public_path__ + "static/media/flop-equity-rangevsrange_0012_thumb.41b03374.jpg";